import { render } from "./DrWizardStartStep.vue?vue&type=template&id=4780d4d2&scoped=true"
import script from "./DrWizardStartStep.vue?vue&type=script&lang=js"
export * from "./DrWizardStartStep.vue?vue&type=script&lang=js"

import "./DrWizardStartStep.vue?vue&type=style&index=0&id=4780d4d2&scoped=true&lang=less"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4780d4d2"]])

export default __exports__